import { NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';

/**
 * Modern carousel image component wrapping NgOptimizedImage
 * with carousel-specific defaults and configuration.
 *
 * Features:
 * - Uses NgOptimizedImage for automatic srcset generation and optimization
 * - Configurable image quality for carousel performance
 * - Fill mode with placeholder for smooth loading
 * - Priority loading support for above-the-fold images
 */
@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'ys-carousel-image',
  imports: [NgOptimizedImage],
  templateUrl: './ys-carousel-image.component.html',
  styleUrl: './ys-carousel-image.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class YsCarouselImageComponent {
  // Image source and metadata
  src = input<string | undefined>();
  alt = input<string | undefined>('Carousel image');
  title = input<string | undefined>();

  // Styling
  imgStyle = input<string | undefined>();
  imgClass = input<string | undefined>();

  // NgOptimizedImage configuration
  sizes = input<string | undefined>();
  loading = input<'lazy' | 'eager' | 'auto' | undefined>('lazy');
  priority = input<boolean | undefined>(false);
  crossOrigin = input<string | undefined>();

  // Carousel-specific configuration
  repo = input<string | null | undefined>(null);
  quality = input<number>(60);
  useFill = input<boolean>(true);
  usePlaceholder = input<boolean>(true);
}
